module.exports = __webpack_public_path__ + "/login_ui/img/mq-e5b6ce6dd68de3fdda02a322e7a919d3.svg";